import { render } from "./UpdateL1L3L4RulesPopUp.vue?vue&type=template&id=97c116b0&scoped=true"
import script from "./UpdateL1L3L4RulesPopUp.vue?vue&type=script&lang=js"
export * from "./UpdateL1L3L4RulesPopUp.vue?vue&type=script&lang=js"

import "./UpdateL1L3L4RulesPopUp.vue?vue&type=style&index=0&id=97c116b0&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97c116b0"]])

export default __exports__